import { useEffect } from 'react';

function GatewayErrorAlert({ error, onClose }) {
  useEffect(() => {
    // Auto-close after 10 seconds
    if (error) {
      const timer = setTimeout(() => {
        onClose();
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [error, onClose]);

  if (!error) return null;

  // Check if this is a gateway configuration error
  const isGatewayError = error.includes('Gateway not connected') || 
                        error.includes('gateway disconnected') ||
                        error.includes('GATEWAY_NOT_CONFIGURED');

  if (!isGatewayError) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={onClose} />
      
      {/* Alert Modal */}
      <div className="relative bg-white rounded-lg shadow-xl max-w-md w-full mx-4 transform transition-all">
        <div className="p-6">
          {/* Error Icon */}
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg
              className="h-6 w-6 text-red-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          
          {/* Title */}
          <h3 className="text-lg font-medium text-gray-900 text-center mb-2">
            Payment Gateway Error
          </h3>
          
          {/* Message */}
          <p className="text-sm text-gray-600 text-center mb-6">
            Gateway not connected, please contact your administrator.
          </p>
          
          {/* Button */}
          <button
            onClick={onClose}
            className="w-full inline-flex justify-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default GatewayErrorAlert;